import { render, staticRenderFns } from "./SaveCompetitionAsFavoriteButton.vue?vue&type=template&id=8c9ec46a&scoped=true"
import script from "./SaveCompetitionAsFavoriteButton.vue?vue&type=script&lang=ts"
export * from "./SaveCompetitionAsFavoriteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9ec46a",
  null
  
)

export default component.exports